import AppConstants from '../constants/AppConstants';

export const initialState = {
    list : [],
    rates: {}
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.CURRENCIES_LOAD_SUCCESS:
            return {
            ...state,
            list: action.items
        };

        case AppConstants.CURRENCY_CURRENT_RATIOS_LOAD_SUCCESS:
            return {
            ...state,
            rates: action.items.rates
        };

        default:
            return state;
    }
};
